import { Order } from 'types/Order'
import moment from 'moment'
import { ORDER_STATUS_CANCELLED, ORDER_STATUS_NEW } from 'Constants/Order/Order.constants'

export function shouldShowPlusLoad(order: Order) {
  const { status, startTime } = order.summary
  const formattedStartTime = startTime.replace(`.`, `:`)
  const isStartTimeToday = moment().startOf(`day`).isSame(moment(formattedStartTime).startOf(`day`))
  return isStartTimeToday && status !== ORDER_STATUS_CANCELLED && status !== ORDER_STATUS_NEW
}
